<template>
  <div id="auth_forgot_userid" class="column">
    <div class="form_container combo_1">
      <div class="language-bar">
        <base-language-bar></base-language-bar>
      </div>
      <img
        class="'mw100 auth_logo combo_1'"
        src="../../assets/images/stratumblue_white_outline_logo.png"
      />
      
      <div class="blu-prices">
        <blu-prices-header></blu-prices-header>
      </div>

      <p class="text_md tal_c">{{ $t("msg.forgot_userid") }}</p>
      <div class="form_block combo_1">
        <input
          class="input_write_form"
          type="text"
          :placeholder="$t('msg.email')"
          :style="errorInputStyle.email"
          v-model="recoverUserIdForm.email"
          @keyup="onChangeRemoveError(recoverUserIdForm, 'email')"
        />
        <span class="help is-danger" v-show="hasError.email">{{
          $t(`msg.${errorMsg.email}`)
        }}</span>
        <p class="text_sm main_white_feel tal_l"></p>
      </div>

      <div class="form_block combo_1">
        <button
          type="submit"
          class="regular_submit"
          @click="submitRecoverUserid"
        >
          {{ $t("msg.recover_userid") }}
        </button>
      </div>

      <div class="column tal_c">
        <router-link :to="{ name: 'recoverpassword' }" exact>
          <a class="main_white_fill text_sm combo_1 dis_b m9_t">
            <span class="fat underline">{{ $t("msg.recover_password") }}</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'login' }" exact>
          <a class="main_white_fill text_sm combo_1 dis_b m9_t">
            {{ $t("msg.already_member", 1) }}
            <span class="fat underline">{{ $t("msg.login") }}</span>
          </a>
        </router-link>

        <router-link :to="{ name: 'signup' }" exact>
          <a class="main_white_fill text_sm combo_1 dis_b m9_t">
            {{ $t("msg.not_member_yet") }}
            <span class="fat underline">{{ $t("msg.open_account") }}</span>
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import BaseWrittenLogo from "../../components/public/BaseWrittenLogo";
import BaseLanguageBar from "../../components/public/BaseLanguageBar";
import BluPricesHeader from "../../components/public/BluPricesHeader";

import { mapGetters } from "vuex";

class RecoverUserIdFields {
  constructor() {
    this.email = "";
  }
}

export default {
  name: "recoveruserid",
  mounted() {
    this.setValidationFields(RecoverUserIdFields);
  },
  data: () => ({
    recoverUserIdForm: new RecoverUserIdFields(),
  }),
  methods: {
    submitRecoverUserid() {
      const form = this.recoverUserIdForm;

      this.showOrHideError("email", this.validateEmail(form.email));

      this.checkIfFormHasErrorsAndSubmit(
        form,
        this.postRecoverUserIdForm,
        this.afterSubmit,
        this.afterSubmitError
      );
    },
    afterSubmit() {
      this.notifySuccess(this.$t("msg.check_your_email_for_userid"));
      this.$router.push("login");
    },
    afterSubmitError(error) {
      this.notifyError(error);
    },
    postRecoverUserIdForm(form) {
      return this.$store.dispatch("postRecoverUid", form.email);
    },
  },
  computed: {
    ...mapGetters(["loading", "currencies"]),
  },
  components: {
    BaseWrittenLogo,
    BaseLanguageBar,
    BluPricesHeader,
  },
};
</script>


// WEBPACK FOOTER //
// src/views/public/RecoverUserid.vue